<template>
  <div v-if="loadEntity">
    <b-row>
      <b-col cols="3">
        <h3>Day</h3>
        <base-input type="date" v-model="from" :required=true />
      </b-col>
    </b-row>

    <b-row v-if="loadTripData">
      <b-col cols="12">
        <trip-card v-for="(item, index) in tripData.tripData.slice().reverse()" :type="type" :tripData="item"></trip-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import TripCard from "./TripCard";
import crudApi from "../../crud/crud-api";
import moment from "moment";

export default {
  name: "entity-trips",
  components: {
    TripCard,
  },
  props: {
    type: {
      type: String,
      default: 'ASSET',
      description: "Types : ASSET, DRIVER"
    },
    entityId: {
      type: String,
      required: true,
      description: "Entity ID"
    }
  },
  created() {
    if (this.$store.state.filter.trip_day) {
      this.from = this.$store.state.filter.trip_day
    }
  },
  data: _ => ({
    entity: {},
    from: moment().format().slice(0,10),
    tripData: {}
  }),
  computed: {
    loadTripData() {
      this.getTripData()

      return true
    },
    loadEntity() {
      this.getEntity()

      return true
    }
  },
  methods: {
    getTripData() {
      let from = new Date()
      if (this.from) {
        from = new Date(this.from+'T'+'00:00:00')
      }

      let until = undefined
      if (this.from) {
        until = new Date(this.from+'T'+'23:59:59')
      }

      if (this.type === 'ASSET') {
        crudApi.getAllVehicleDrivingStyleData(this.$store.state.auth.user.organisation_id, from, until, [ this.entityId ], undefined, true, null, 100, 0).then(json => this.tripData = json.data ? json.data : json);
      } else {
        crudApi.getAllDriverDrivingStyleData(this.$store.state.auth.user.organisation_id, from, until, [ this.entityId ], undefined, true, null, 100, 0).then(json => this.tripData = json.data ? json.data : json);
      }
    },
    getEntity() {
      if (this.type === 'ASSET') {
        crudApi.getAsset(this.entityId).then(json => this.entity = json.data ? json.data : json)
      } else {
        crudApi.getDriver(this.entityId).then(json => this.entity = json.data ? json.data : json)
      }
    }
  },
  watch: {
    from: function() {
      this.$store.state.filter.trip_day = this.from
    }
  }
}
</script>

<style scoped>

</style>
